import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { paths } from '@/constants';
import { useCommentsList as useCommentsListEntity } from '@/data/entities/comments';
import type { CommentableModel } from '@/enums';
import { useProjectId } from '@/hooks';
import { usePrefValue } from '@/preferences';

interface UseCommentsListOptions {
    commentableIds: number[];
    commentableModel: CommentableModel;
    enabled?: boolean;
}

export function useCommentsList(options: UseCommentsListOptions) {
    const project_id = useProjectId();
    const scene_id = usePrefValue('editor_scene').id;
    const location = useLocation();
    const isEditor = location.pathname === paths.project.scene.editor || location.pathname === paths.project.scene.editor_pep;

    const isEnabled = options.commentableIds.length > 0 && options.enabled !== false && !!project_id;
    const { data, isLoading, error, refetch } = useCommentsListEntity(
        {
            projectId: project_id ?? 0,
            commentableId: options.commentableIds,
            commentableModel: options.commentableModel,
        },
        { enabled: isEnabled },
    );

    const comments = useMemo(() => {
        if (isEditor && scene_id && data) {
            return data.filter(item => item.commentable.textable?.id === scene_id);
        }
        return data ?? [];
    }, [data, isEditor, scene_id]);

    return { comments, isLoading, error, refetch };
}
